document.addEventListener('DOMContentLoaded', function () {

  function applyRegionToSelect(selector) {
    if (!selector) return;

    const countryISO = Shopify.country;
    const regionMap = {
      'CA': 'canada',
      'AU': 'australia / nz',
      'NZ': 'australia / nz',
      'US': 'usa',
      'AL': 'europe (eu)', 'AD': 'europe (eu)', 'AT': 'europe (eu)', 'BY': 'europe (eu)',
      'BE': 'europe (eu)', 'BA': 'europe (eu)', 'BG': 'europe (eu)', 'CH': 'europe (eu)',
      'CY': 'europe (eu)', 'CZ': 'europe (eu)', 'DE': 'europe (eu)', 'DK': 'europe (eu)',
      'EE': 'europe (eu)', 'ES': 'europe (eu)', 'FI': 'europe (eu)', 'FR': 'europe (eu)',
      'GB': 'europe (eu)', 'GR': 'europe (eu)', 'HR': 'europe (eu)', 'HU': 'europe (eu)',
      'IE': 'europe (eu)', 'IS': 'europe (eu)', 'IT': 'europe (eu)', 'LI': 'europe (eu)',
      'LT': 'europe (eu)', 'LU': 'europe (eu)', 'LV': 'europe (eu)', 'MC': 'europe (eu)',
      'MD': 'europe (eu)', 'ME': 'europe (eu)', 'MK': 'europe (eu)', 'MT': 'europe (eu)',
      'NL': 'europe (eu)', 'NO': 'europe (eu)', 'PL': 'europe (eu)', 'PT': 'europe (eu)',
      'RO': 'europe (eu)', 'RS': 'europe (eu)', 'SE': 'europe (eu)', 'SI': 'europe (eu)',
      'SK': 'europe (eu)', 'SM': 'europe (eu)', 'UA': 'europe (eu)', 'XK': 'europe (eu)'
    };

    const matchedRegion = regionMap[countryISO] || 'rest of world';

    const options = selector.options;
    for (let i = 0; i < options.length; i++) {
      const label = options[i].textContent.trim().toLowerCase();
      if (label === matchedRegion) {
      selector.selectedIndex = i;
selector.dispatchEvent(new Event('change', { bubbles: true }));

// 🔥 Re-sync the hidden input inside the same form
const form = selector.closest('form');
const hiddenInput = form?.querySelector('input[name="id"]');
if (hiddenInput) hiddenInput.value = selector.value;

break;
      }
    }
  }

  function runSafeVariantSelector() {
    if (typeof Shopify === 'undefined' || !Shopify.country) {
      return setTimeout(runSafeVariantSelector, 100);
    }

    document.querySelectorAll('select[name="id"]').forEach(select => {
      applyRegionToSelect(select);
    });
  }

  runSafeVariantSelector();

  // 👇 Observe for dynamically added forms (like upsell modal)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          const selects = node.querySelectorAll
            ? node.querySelectorAll('select[name="id"]')
            : [];

          selects.forEach(select => applyRegionToSelect(select));
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (typeof updateBISButtonDisplay === 'function') updateBISButtonDisplay();
});